
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { useFamilyForm } from "./FamilyFormContext";
import { PlusCircle, Trash2 } from "lucide-react";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

export function SiblingsSection() {
  const { siblings, addSibling, updateSibling, removeSibling } = useFamilyForm();
  const { language } = useLanguage();

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label className="text-base">{t('family.siblings', language)}</Label>
        <Button 
          type="button" 
          variant="ghost" 
          size="sm" 
          onClick={addSibling}
          className="flex items-center text-primary"
        >
          <PlusCircle className="h-4 w-4 mr-1" />
          {language === 'ja' ? '兄弟姉妹を追加' : 'Add Sibling'}
        </Button>
      </div>
      
      {siblings.length === 0 && (
        <p className="text-sm text-muted-foreground italic text-center py-2">
          {language === 'ja' ? 'まだ兄弟姉妹が追加されていません' : 'No siblings added yet'}
        </p>
      )}
      
      {siblings.map((sibling) => (
        <div key={sibling.id} className="space-y-2 p-3 border rounded-md relative">
          <div className="space-y-2">
            <Label htmlFor={`sibling-name-${sibling.id}`}>
              {language === 'ja' ? '名前' : 'Name'}
            </Label>
            <Input
              id={`sibling-name-${sibling.id}`}
              value={sibling.name}
              onChange={(e) => updateSibling(sibling.id, "name", e.target.value)}
              placeholder={language === 'ja' ? '兄弟姉妹の名前を入力' : "Enter sibling's name"}
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor={`sibling-birthday-${sibling.id}`}>
              {language === 'ja' ? '誕生日（任意）' : 'Birthday (optional)'}
            </Label>
            <Input
              id={`sibling-birthday-${sibling.id}`}
              type="date"
              value={sibling.birthday || ""}
              onChange={(e) => updateSibling(sibling.id, "birthday", e.target.value)}
            />
          </div>
          
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={() => removeSibling(sibling.id)}
            className="absolute top-2 right-2 h-7 w-7 text-destructive"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      ))}
    </div>
  );
}
